import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './LayoutGallery.css';
import ScrollArrow from '../scroll-arrow/ScrollArrow';
import { GetActivePage } from '../../redux/helpers';
import CategoryColors from './CategoryColors';
import { getBackgrounsByLayoutType } from '../../redux/helpers/layouts';

class LayoutGallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayTopArrow: false,
      displayBottomArrow: false,
    };
  }

  componentWillReceiveProps() {
    setTimeout(() => {
      this.toggleArrow();
    }, 200);
  }

  setLayout = () => {
    const {
      pagesById, backgrounds, layouts, dispatch, hasParent,
    } = this.props;
    const currentPage = GetActivePage(pagesById);
    if (!currentPage) {
      return null;
    }
    const { backgroundImages } = currentPage;

    if ('type' in backgroundImages && 'category' in backgroundImages) {
      const { type, category } = backgroundImages;
      const getBackground = getBackgrounsByLayoutType(pagesById, layouts, backgrounds.backgrounds);
      if (getBackground) {
        const backgroundType = Object.values(getBackground).find(el => el.name === type);
        if (backgroundType) {
          const backgroundColor = Object.values(backgroundType.items).find(el => el.name === category);
          if (backgroundColor) {
            const { images } = backgroundColor;
            return (<CategoryColors
              layouts={layouts}
              dispatch={dispatch}
              currentPage={currentPage}
              images={images}
              backgrounds={backgrounds}
              hasParent={hasParent}
            />);
          }
        }
      }
    }
    return null;
  }

  toggleTopArrow = (visible) => {
    this.setState({
      displayTopArrow: visible,
    });
  }

  toggleBottomArrow = (visible) => {
    this.setState({
      displayBottomArrow: visible,
    });
  }

  displayArrow = (direction, target, state, className) => (
    state ?
      <ScrollArrow
        direction={direction}
        classes={`${className} galleryScroll`}
        target={target}
        vertical
      />
      :
      ''
  )

  toggleArrow = () => {
    if (!this.refs.scrollWrapper) {
      return false;
    }

    const {
      scrollLeft,
      scrollWidth,
      clientWidth,
    } = this.refs.scrollWrapper;

    if (scrollLeft > 0) {
      this.toggleTopArrow(true);
    }

    if (scrollLeft === 0) {
      this.toggleTopArrow(false);
    }

    if (scrollLeft + clientWidth === scrollWidth) {
      this.toggleBottomArrow(false);
    }

    if (scrollLeft + clientWidth !== scrollWidth) {
      this.toggleBottomArrow(true);
    }
  }


  renderLayouts = () => (
    <div className="scrollarea-content custom-scrollbar">
      <div className="scroll" ref="scrollWrapper" onScroll={() => this.toggleArrow()} >
        { this.setLayout()}
      </div>
    </div>
  )


  render() {
    const {
      displayTopArrow,
      displayBottomArrow,
    } = this.state;
    const { lang, hasParent } = this.props;

    const displayText = (Object.keys(hasParent).length === 0);

    return (
      <div className="LayoutGallery" style={{ height: 160 }}>
        { displayText && <p className="LayoutGallery--text">{lang.otherColors}</p> }
        { this.displayArrow('left', '.LayoutGallery .scroll', displayTopArrow, 'ScrollLeft') }
        { this.renderLayouts() }
        { this.displayArrow('right', '.LayoutGallery .scroll', displayBottomArrow, 'ScrollRight') }
      </div>
    );
  }
}

LayoutGallery.defaultProps = {
  pagesById: {},
  backgrounds: {},
  layouts: {},
  dispatch: () => {},

};

LayoutGallery.propTypes = {
  pagesById: PropTypes.object,
  backgrounds: PropTypes.object,
  layouts: PropTypes.object,
  dispatch: PropTypes.func,

};


export default connect(state => ({
  pagesById: state.entities.pages.byId,
  layouts: state.entities.layouts.byId,
  backgrounds: state.backgrounds,
  hasParent: state.bookProperties.parentStyle,
}))(LayoutGallery);



// WEBPACK FOOTER //
// ./src/components/layout-gallery/LayoutGallery.jsx